import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.70711 3.29289C10.0976 3.68342 10.0976 4.31658 9.70711 4.70711L5.41421 9H13C15.3869 9 17.6761 9.94821 19.364 11.636C21.0518 13.3239 22 15.6131 22 18V20C22 20.5523 21.5523 21 21 21C20.4477 21 20 20.5523 20 20V18C20 16.1435 19.2625 14.363 17.9497 13.0503C16.637 11.7375 14.8565 11 13 11H5.41421L9.70711 15.2929C10.0976 15.6834 10.0976 16.3166 9.70711 16.7071C9.31658 17.0976 8.68342 17.0976 8.29289 16.7071L2.29289 10.7071C1.90237 10.3166 1.90237 9.68342 2.29289 9.29289L8.29289 3.29289C8.68342 2.90237 9.31658 2.90237 9.70711 3.29289Z" fill="currentColor" />
  </svg>
);

const ReplyIcon = (props) => <Icon component={SVG} {...props} />;

export default ReplyIcon;
